import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-back-top-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_up_outlined = _resolveComponent("up-outlined")!
  const _component_a_back_top = _resolveComponent("a-back-top")!

  return (_openBlock(), _createBlock(_component_a_back_top, { target: $setup.getScrollDom }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_up_outlined, { style: {"font-size":"0.5rem","color":"#bbbcbc"} })
      ])
    ]),
    _: 1
  }, 8, ["target"]))
}